export default function sortObjects(objs, compare, tiebreaker = () => 0) {
  return [...objs].sort((objA, objB) => {
    return compare(objA, objB) || tiebreaker(objA, objB);
  });
}
